import { render, staticRenderFns } from "./add_project_status.vue?vue&type=template&id=46ee438c&scoped=true&"
import script from "./add_project_status.vue?vue&type=script&lang=js&"
export * from "./add_project_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee438c",
  null
  
)

export default component.exports